// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import { IDynamicBindableValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { ProductsOnTheWayDataType } from '../products-on-the-way/products-on-the-way-helpers';
import { Product } from 'graphql-api/gql-api-interfaces';
import { MediaType } from '@epicuro-next/models/engagement';
import {
  RecommendedItemsResponseType,
  RecommendedItemTypeProductsOnTheWay,
} from 'models-recommendation';

export function getDataFromRecommendations(): IDynamicBindableValue {
  return {
    provider: 'HttpBodyProvider',
    property: {
      values: [
        {
          provider: 'id:root',
          property: 'panelName',
        },
        {
          provider: 'id:root',
          property: 'apiRequestPayloadPropertiesProvider',
        },
      ],
      transform: function ([panelName, apiRequestPayloadProperties]: [
        string,
        { [key: string]: unknown },
      ]) {
        const body = {
          panelType: panelName,
          properties: {
            ...apiRequestPayloadProperties,
          },
        };

        const url = '/api/v2/recommendation/suggest';
        const method = 'POST';
        const fetchString =
          window.neoclesDynamicFramework.recommendationsPanels.methods.createHttpRequestFetchString(
            url,
            method,
            body,
          );
        return fetchString;
      }.toString(),
    },
    transform: transformHttpBodyToProductsData.toString(),
  };
}

function transformHttpBodyToProductsData(
  recommendedItemsResponse: RecommendedItemsResponseType<RecommendedItemTypeProductsOnTheWay>,
): unknown {
  const productsData: ProductsOnTheWayDataType[] = [];
  for (const itemInDataSet of recommendedItemsResponse.result.dataSet) {
    const item = itemInDataSet.item;
    const product = item.product;

    if (product === undefined || product === null) {
      // This should never be the case, BE should either return it or not.
      // At the time of writing it is a known issue that sometimes the product is not defined.
      continue;
    }

    const productData: ProductsOnTheWayDataType = {
      media: {
        mediaType: 'IMAGE' as MediaType,
        url: product.media?.[0]?.src?.[0]?.url ?? '',
      },
      configStrip: {
        overlayPath: [
          'cs',
          product.brandId,
          product.masterProduct?.productId ?? 'PARENT ID NA',
          product.productId,
        ],
      },
      product: {
        ...product,
        articleTitle: product.title,
      } as unknown as Product,
      deliveryDate: item.deliveryDate,
      sizes: item.sizes,
      correlationId: recommendedItemsResponse.operationId,
      servingConfig: recommendedItemsResponse.result.metadata.provider,
      providerId: recommendedItemsResponse.result.metadata.providerid,
      attributionToken: null,
      hash: recommendedItemsResponse.hash,
    };

    productsData.push(productData);
  }
  return productsData;
}
